import { Chip } from "@mui/material";
import { STATUS_EXECUCAO_LABEL, type StatusExecucao } from "@/api/escala.service";

const STATUS_CHIP_COLOR: Record<StatusExecucao, "info" | "success" | "warning" | "error"> = {
  RODANDO: "info",
  OK: "success",
  PARCIAL: "warning",
  ERRO: "error",
};

// Situação de uma execução da sincronização com o sistema externo.
export function StatusExecucaoChip({ status }: { status: StatusExecucao }) {
  return <Chip size="small" label={STATUS_EXECUCAO_LABEL[status]} color={STATUS_CHIP_COLOR[status]} />;
}
